import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./header.css";
import { Link, useNavigate, NavLink } from "react-router-dom";
import "./header.css";
import Notification from "./../notification";
import Profile from "../profile";
import QuickOrderPopup from "../quickOrderPopup";
import CartSummary from "../cartSummery";
import { useDispatch, useSelector } from "react-redux/es/exports";
import { log } from "console";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import * as PusherPushNotifications from "@pusher/push-notifications-web";
import { ToastContainer } from "react-toastify";
import Pusher from "pusher-js";
import {
  mobilemenu,
  moreitems,
  quickorder,
  myprofile,
  logout,
  phonecall,
  cart,
  loguser,
  stimg
} from "../../assets/img";
import { fetchHomeJsonList, getHomeJsonList } from "../../redux/Actions";
import { checkShopListFlow } from "../../utility";

// import ReactGA from 'react-ga';

// const TRACKING_ID = "UA-265690492-2"; // OUR_TRACKING_ID
// ReactGA.initialize(TRACKING_ID);

const getUser = () => {
  const token: any = localStorage.getItem("userDetails");
  return token ? JSON.parse(token) : "";
};

function HeaderIhateIroning() {
  const [changePopup, setChangePopup] = useState(false);
  const [changePopupProfile, setChangePopupProfile] = useState(false);
  const [quickBookPopup, setQuickBookPopup] = useState(false);
  const [cartSummary, setCartSummary] = useState(false);
  const [userName, setUserName] = useState<any>("");
  const [userToken, setUserToken] = useState();

  const [cartValue, setCartValue] = useState<any>([]);
  const [pusherKey, setpusherKey] = useState<any>("");
  const state: any = useSelector<any>((state) => state);
  const menuRef = React.useRef<HTMLDivElement>(null);
  const { cartCount }: any = useSelector<any>((state) => state);
  const [notifyCount, setNotifyCount] = useState<any>([]);
  const [cartCounts, setCartCount] = useState<number>(0);
  const [finalTotalPrice, setFinalTotalPrice] = useState<number>(0);
  const name = localStorage.getItem("username");

  const shopHomeData: any = useSelector<any>((state) => state?.shopHome);

  const dispatch = useDispatch<any>();

  const homedata: any = useSelector<any>((state) => state?.homeJsonList);
  useEffect(() => {}, [homedata]);

  useEffect(() => {}, [window.location.href]);

  const selectedCategories: any = useSelector<any>(
    (state) => state.userSelectedCategories
  );

  const settingsData: any = useSelector<any>((state) => state?.settings);

  const base_url = process.env.REACT_APP_BACKEND_URL;
  const Url = window.location.host;
  const blogUrl = `https://blog.${Url}`;
  const shopurl = 'https://bestatlaundry.com/laundry'
  const activeUrl = window.location.pathname;
  const [settings, setSettings] = useState<any>({});
  const [shopHome, setShopHome] = useState<any>(false);
  let shopURL = window.location.href;
  useEffect(() => {
    dispatch(getHomeJsonList());
    const shopName: any = localStorage.getItem("currentShopName");
    if (shopName) {
      const finalResult = shopName
        .trim()
        .replace(/\s(.)/g, (match: any) => match.toUpperCase())
        .replace(/\s/g, "")
        .replace(/^(.)/, (match: any) => match.toLowerCase());
      if (shopName) {
        setShopHome(true)
      } else {
        setShopHome(false)
      }
    }
  }, []);
  useEffect(() => {
    setSettings(settingsData);
  }, [settingsData]);
  useEffect(() => {
    if (state.userDetails.data) {
      const user_info = state.userDetails.data?.user_info;
      const { name = "" } = user_info;
      // const token = getToken();
      setUserToken(name);
      setUserName(name);
    }

    const selectedMainCategory = selectedCategories?.filter((item: any) => {
      return item?.sub_categories?.some(
        (subItem: any) => parseInt(subItem?.quantity) > 0
      );
    });

    let finalTotalPrice = 0;
    let itemsCount = 0;

    if (selectedMainCategory.length) {
      selectedMainCategory?.map((item: any) => {
        const subcategoryList = item?.sub_categories?.filter(
          (subItem: any) => parseInt(subItem.quantity) > 0
        );
        itemsCount = itemsCount + subcategoryList?.length;
        subcategoryList?.map((subcategory: any) => {
          finalTotalPrice =
            finalTotalPrice +
            parseInt(subcategory?.quantity) *
              parseFloat(subcategory?.total_price);
        });
      });

      // cartInformationData?.map((item: any) => {
      //   const subcategoryList = item?.sub_categories?.filter(
      //     (subItem: any) => parseInt(subItem.quantity) > 0);
      // });
    }
    setFinalTotalPrice(finalTotalPrice);
    setCartCount(itemsCount);
  }, [state]);

  const navigate = useNavigate();
  const handleLogout = (e: any) => {
    e.preventDefault();
    localStorage.clear();
    navigate("/login");
    window.location.reload();
  };
  useEffect(() => {
    AOS.init();
    // AOS.refresh();
  }, []);

  const [sticky, setSticky] = useState("");

  // on render, set listener
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  const isSticky = () => {
    const scrollTop = window.scrollY;
    const stickyClass = scrollTop >= 100 ? "fixed" : "";
    setSticky(stickyClass);
  };

  const fixedheader = `header headerf headershopeleven ${sticky}`;
  function addNotify() {
    setNotifyCount((prevState: any) => [...prevState, "1"]);
  }

  let oldNotify = "";

  useEffect(() => {
    if (localStorage.getItem("userDetails")) {
      const userInfo = JSON.parse(localStorage.getItem("userDetails")!);

      const { data } = userInfo;

      if (data != null) {
        // const notifyLocalCount = localStorage.getItem('notifyCount');

        const interest = data.user_info.notification_interest_list;

        if (interest[1] != undefined) {
          const intrst = interest[1];
          var pusher = new Pusher(pusherKey, {
            cluster: "eu",
          });

          var channel = pusher.subscribe(intrst);
          channel.bind("my-event", function (datas: any) {
            let event = datas.order;
            // alert(event.title);
            // toast.dismiss();

            // setNotifyCount(notifyCount);

            // var newArray = notifyCount.concat('1');

            //

            // const rand = Math.random();

            // setNotifyCount(notifyCount.concat(rand));
            // setNotifyCount((prevState: any) => ([...prevState, '1']))

            if (oldNotify != event.order_id) {
              addNotify();
              oldNotify = event.order_id;
            }

            // localStorage.setItem('notifyCount', `${parseInt(notifyLocalCount!) + 1}`);

            // setNotifyCount(notifyCount + 1);
            // toast(<div>{event.title}<br />{event.body}</div>, { autoClose: false });
          });
        }
      }

      if (data) {
        const user_info = data?.user_info;
        const { name = "" } = user_info;
        // const token = getToken();
        setUserToken(name);
        setUserName(name);
      }

      // setUserToken(token);
    }
    let handler = (event: { target: Node | null }) => {
      if (menuRef.current) {
        if (!menuRef.current.contains(event.target)) {
          setChangePopupProfile(false);
          setCartSummary(false);
        }
      }
    };
    document.addEventListener("mousedown", function name(params: any) {
      handler(params);
    });
    document.addEventListener("scroll", function name() {
      // AOS.init();
      AOS.refresh();
    });
  }, []);

  const location = useLocation();
  let newurl = location.pathname;
  let splitURL: any = newurl.toString().split("/");

  useEffect(() => {
    sidebarClose();
    cartboxClose();
  }, [location]);

  var sidebar = document.getElementById("sidebar");
  var overlay = document.getElementById("overlay");
  var cartoverlay = document.getElementById("cd-shadow-layer");
  var cdcart = document.getElementById("cd-cart");

  const cartboxClose = () => {
    cdcart?.classList.remove("speed-in");
    cartoverlay?.classList.remove("is-visible");
  };
  const cartboxOpen = () => {
    cdcart?.classList.add("speed-in");
    cartoverlay?.classList.add("is-visible");
  };

  const sidebarClose = () => {
    sidebar?.classList.remove("active");
    overlay?.classList.remove("active");
  };
  const sidebarOpen = () => {
    sidebar?.classList.add("active");
    overlay?.classList.add("active");
  };

  function openQuickOrderPopup() {
    setQuickBookPopup(!quickBookPopup);
    localStorage.setItem("disableLoader", "yes");
  }
  function closeQuickOrderPopup() {
    setQuickBookPopup(false);
    localStorage.removeItem("disableLoader");
  }

  return (
    <div>
      {/* <div className="home-offer">
          <p className="title">Limited Time Offer 32% Discount on First Booking</p><button className="btn">Know More</button>
          <a className="home-offer-close"><i className="uil uil-times-circle"></i></a>
      </div> */}      
      <header
        className={fixedheader}
      >
        <div className="header-top">
          <div className="container-fluid">
            <div className="row header-nav">
              <div className="col-md-auto col-sm-12">
                <div className="logo">
                  <span
                    id="sidebarCollapse"
                    className="d-block d-md-none sidebarmenu" 
                    onClick={sidebarOpen}
                  >
                  </span>
                  {shopHome ? (
                    <Link to="/">
                      <img
                        id="site_logo"
                        src={`${shopHomeData?.home_page_settings?.shop_home_page_image.logo[0].file_name}`}
                        alt=""
                      />
                    </Link>
                  ) : (
                    <Link to="/">
                      <img
                        id="site_logo"
                        src={`${settings?.WebsiteSettings?.logo_path}${settings?.WebsiteSettings?.style_logo_en}`}
                        alt=""
                      />
                    </Link>
                  )}
                  {/* <Link to="/">
                    <img
                      id="site_logo"
                      src={`${
                        Object.keys(settings).length > 0 &&
                        settings.WebsiteSettings.logo_path
                      }${
                        Object.keys(settings).length > 0 &&
                        settings.WebsiteSettings.style_logo_en
                      }`}
                      // src={`${Object.keys(settings).length > 0 && settings.WebsiteSettings.style_logo_en}`}
                      alt=""
                    />
                  </Link> */}
                  <span className="mob-user hidden-md dropdown d-block d-md-none">
                        <a
                          className="more-items"
                          data-bs-toggle="dropdown"
                          href="#"
                        ></a>
                    <ul
                      role="menu"
                      className="dropdown-menu"
                      aria-labelledby="drop1"
                    >
                      {homedata?.theme_3?.home?.header?.btn_group?.btn2
                        ?.btn2_is_enable && (
                          <>
                          {settingsData?.quick_order_mode != 0 &&
                        <li>
                          <a
                            href="javascript:void(0);"
                            data-bs-toggle="modal"
                            data-bs-target="#quickordermodal"
                            style={{
                              background: `${homedata?.theme_3?.home?.btn_group?.btn2?.bg_color}`,
                              color: `${homedata?.theme_3?.homedata?.theme_3?.home?.btn_group?.btn2?.color}`,
                              borderColor: `${homedata?.theme_3?.home?.btn_group?.btn2?.border_color}`,
                            }}
                          >
                            <i className="uil uil-shopping-cart-alt"></i>
                            {
                              homedata?.theme_3?.home?.header?.btn_group?.btn2
                                ?.text
                            }
                          </a>
                        </li>
                          }
                        </>
                      )}
                      {!userToken && (
                        <li className="login">
                          <Link
                            to="/login"
                            style={{
                              background: `${homedata?.theme_3?.home?.btn_group?.btn1?.bg_color}`,
                              color: `${homedata?.theme_3?.homedata?.theme_3?.home?.btn_group?.btn1?.color}`,
                              borderColor: `${homedata?.theme_3?.home?.btn_group?.btn1?.border_color}`,
                            }}
                          >
                            <i className="uil uil-user-circle"></i>{" "}
                            {
                              homedata?.theme_3?.home?.header?.btn_group?.btn1
                                ?.text
                            }
                          </Link>
                        </li>
                      )}
                      {userToken && (
                        <li className="dropdown menu-hover-dropdown">
                          <a
                            className="menuitem"
                            href="#"
                            onClick={(e) => handleLogout(e)}
                            style={{
                              background: `${homedata?.theme_3?.home?.btn_group?.btn1?.bg_color}`,
                              color: `${homedata?.theme_3?.homedata?.theme_3?.home?.btn_group?.btn1?.color}`,
                              borderColor: `${homedata?.theme_3?.home?.btn_group?.btn1?.border_color}`,
                            }}
                          >
                            <i className="uil uil-sign-out-alt"></i>
                            {
                              homedata?.theme_3?.home?.header?.btn_group?.btn1
                                ?.text
                            }
                          </a>
                        </li>
                      )}
                    </ul>
                  </span>
                </div>
                {settings?.WebsiteSettings?.site_title_en ==
                  "Insta Laundry" && (
                  <div className="contact">
                    <ul className="header-topnav-contact">
                      <li>
                        <a
                          href={`tel:${homedata?.home?.footer?.footer_section?.callnow_for_Services_section?.mbl_no?.label}`}
                          className=""
                        >
                          <i className="uil uil-phone"></i>
                          {
                            homedata?.home?.footer?.footer_section
                              ?.callnow_for_Services_section?.mbl_no?.label
                          }
                        </a>
                      </li>
                      <li>
                        <a
                          href={`mailto:${homedata?.home?.footer?.footer_section?.callnow_for_Services_section?.email?.value}`}
                          className=""
                        >
                          <i className="uil uil-envelope me-2"></i>
                          {
                            homedata?.home?.footer?.footer_section
                              ?.callnow_for_Services_section?.email?.value
                          }
                        </a>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
              <div className="col-md col-sm-12">
                <div
                  className="d-none d-md-flex align-items-center h-100"
                  ref={menuRef}
                >
                  {shopURL?.includes("starcraftdrycleaners") && (  
                    <div className="starwelimg">
                      <img src={stimg} alt=""/>  
                    </div>   
                    )
                  }
                  <ul className="header-link header-link-h">
                    <li className="menu-hover">
                      {activeUrl === "/" ? (
                        <NavLink className="nav-bar-link active" to="/">
                          Home
                        </NavLink>
                      ) : (
                        <NavLink className="nav-bar-link" to="/">
                          Home
                        </NavLink>
                      )}
                    </li>
                    {!checkShopListFlow() && 
                    <li className="menu-hover">
                      {activeUrl === "/pricing" ? (
                        <NavLink className="nav-bar-link active" to="/pricing">
                          Pricing
                        </NavLink>
                      ) : (
                        <NavLink className="nav-bar-link" to="/pricing">
                          Pricing
                        </NavLink>
                      )}
                    </li>
                    }
                    <li className="menu-hover">
                      {activeUrl === "/areaCovered" ? (
                        <NavLink
                          className="nav-bar-link active"
                          to="/areaCovered"
                        >
                          Area Covered
                        </NavLink>
                      ) : (
                        <NavLink className="nav-bar-link" to="/areaCovered">
                          Area Covered
                        </NavLink>
                      )}
                    </li>
                    {settings?.WebsiteSettings?.site_title_en ==
                      "Insta Laundry" && (
                      <li className="faq-menu menu-hover">
                        {activeUrl === "/aboutUs" ? (
                          <NavLink
                            className="nav-bar-link active"
                            to="/aboutUs"
                          >
                            About Us
                          </NavLink>
                        ) : (
                          <NavLink className="nav-bar-link" to="/aboutUs">
                            About Us
                          </NavLink>
                        )}
                      </li>
                    )}
                    {checkShopListFlow() && splitURL.length < 3 &&
                      <li className="faq-menu menu-hover">
                        <a target="_blank" href={shopurl} className="signup-m">List Your Laundry</a>
                      </li>
                    }
                    {userToken && (
                      <li className="dropdown menu-hover-dropdown cart-list dropdown-notification">
                        <Link
                          to="#"
                          id="drop1"
                          data-bs-toggle="dropdown"
                          className="dropdown-toggle"
                        >
                          <i
                            className="fa fa-bell pt-2"
                            aria-hidden="true"
                            onClick={() => setChangePopup(!changePopup)}
                          ></i>
                          {/* <span
                            id="notify_total_count"
                            className="count-blk pb-1"
                          >
                            {notifyCount.length}
                          </span> */}
                        </Link>
                        <div className="dropdown-menu">
                          <Notification />
                        </div>
                      </li>
                    )}
                    {!userToken &&
                    homedata?.theme_3?.home?.header?.btn_group?.btn1
                        ?.btn1_is_enable === true && (
                        <>
                        <li className="menu-hover">
                            <Link
                            to="/login"
                            
                            >
                            Login
                            </Link>
                        </li>
                        </>
                    )}
                    {userToken && (
                      <li className="dropdown menu-hover-dropdown">
                        <Link
                          to="#"
                          id="drop1"
                          data-bs-toggle="dropdown"
                          className="dropdown-toggle"
                          role="button"
                          onClick={() =>
                            setChangePopupProfile(!changePopupProfile)
                          }
                        >
                          {`Hi ${name || userName}!`}
                          <b className="caret"></b>
                        </Link>
                        <div className="dropdown-menu">{<Profile />}</div>
                      </li>
                    )}
                  </ul>
                  {activeUrl != "/checkout" && (
                    <ul className="header-link-right d-none">
                      {/* <li className="d-none d-xl-inline-block"><a href={`tel:${settingsData?.WebsiteSettings?.contact_t5}`}><img src={phonecall} alt="" /><span>{settingsData?.WebsiteSettings?.contact_t5}</span></a></li> */}
                      <li>
                        <div
                          className="header-cart-box"
                          onClick={cartboxOpen}
                        >
                          <i
                            className="uil uil-shopping-cart"                           
                          ></i>
                          <div className="cart-box-info">
                            <span
                              id="cart_total_count">
                              {
                                homedata?.theme_3?.home?.header?.nav
                                  ?.cart_section?.cart_label_section?.label
                              }{" "}
                              {cartCounts}
                            </span>
                            <span
                              
                              className="count-blk title"
                            >
                              {settingsData?.WebmasterSettings?.currency}
                              {finalTotalPrice.toFixed(2)}
                            </span>
                          </div>
                        </div>
                      </li>
                      {!userToken &&
                        homedata?.theme_3?.home?.header?.btn_group?.btn1
                          ?.btn1_is_enable === true && (
                          <>
                            <li className="header-auth header-box menu-hover">
                              <Link
                                to="/login"
                                
                              >
                                <i className="uil uil-users-alt"></i>
                                {
                                  homedata?.theme_3?.home?.header?.btn_group
                                    ?.btn1?.text
                                }
                              </Link>
                            </li>
                          </>
                        )}
                      {settingsData?.quick_order_mode != 0 && 
                      homedata?.theme_3?.home?.header?.btn_group?.btn2
                        ?.btn2_is_enable === true ? (
                        <>
                          <li
                            className="login menu-hover">
                            <Link
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target="#quickordermodal"
                              className="title-btn btn"
                              style={{
                                border: `2px solid #${homedata?.theme_3?.home?.header?.btn_group?.btn2?.border_color}`,
                                background: `#${homedata?.theme_3?.home?.header?.btn_group?.btn2?.bg_color}`,
                                color: `#${homedata?.theme_3?.home?.header?.btn_group?.btn2?.color}`,
                              }}
                            >
                              <i className="uil uil-shuffle"></i>
                              {
                                homedata?.theme_3?.home?.header?.btn_group?.btn2
                                  ?.text
                              }
                            </Link>
                          </li>
                        </>
                      ) : null}
                    </ul>
                  )}
                  {shopURL?.includes("alixdrycleaning") && (
                    <ul className="flapplinks mt-0">
                        {settingsData?.WebsiteSettings?.social_link1 != '' && (
                          <li className="p-3" style={{cursor: 'pointer'}}>
                            <a href={`${settingsData?.WebsiteSettings?.social_link1}`} target="_blank"><i className="fab fa-facebook"></i></a>
                          </li>
                        )}
                        {settingsData?.WebsiteSettings?.contact_t3 != '' && (
                          <li className="p-3" style={{cursor: 'pointer'}}>
                            <a href={`tel:${settingsData?.WebsiteSettings?.contact_t3}`} target="_blank"><i className="fas fa-phone"></i></a>
                          </li>
                        )}
                        {settingsData?.WebsiteSettings?.contact_t6 != '' && (
                          <li className="p-3" style={{cursor: 'pointer'}}>
                            <a href={`mailto:${settingsData?.WebsiteSettings?.contact_t6}`} target="_blank"><i className="fas fa-envelope"></i></a>
                          </li>
                        )}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <nav
        id="sidebar"
        className="mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar"
        style={{ overflow: "visible" }}
      >
        <div
          id="mCSB_1"
          className="mCustomScrollBox mCS-minimal mCSB_vertical mCSB_outside"
          style={{ maxHeight: "480px" }}
        >
          <div
            id="mCSB_1_container"
            className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
            style={{ position: "relative", top: "0px", left: "0px" }}
            dir="ltr"
          >
            <div id="dismiss" onClick={sidebarClose}>
              <i className="fa fa-arrow-left"></i>
            </div>
            <div className="sidebar-header"></div>
            <ul className="list-unstyled components">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/pricing">Pricing</Link>
              </li>
              <li>
                <Link to="/areaCovered">Area Covered</Link>
              </li>
              {checkShopListFlow() && splitURL.length < 3 &&
                <li className="btnmoblist">
                  <a target="_blank" href={shopurl} className="btn">List Your Laundry</a>
                </li>
              }
            </ul>
          </div>
        </div>
        <div
          id="mCSB_1_scrollbar_vertical"
          className="mCSB_scrollTools mCSB_1_scrollbar mCS-minimal mCSB_scrollTools_vertical"
          style={{ display: "none" }}
        >
          <div className="mCSB_draggerContainer">
            <div
              id="mCSB_1_dragger_vertical"
              className="mCSB_dragger"
              style={{
                position: "absolute",
                minHeight: "0px",
                height: "0px",
                top: "0px",
                display: "block",
              }}
            >
              <div
                className="mCSB_dragger_bar"
                style={{ lineHeight: "0px" }}
              ></div>
            </div>
            <div className="mCSB_draggerRail"></div>
          </div>
        </div>
      </nav>
      <div id="overlay" onClick={sidebarClose}></div>
      <div
        className="modal fade"
        id="quickordermodal"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
              <QuickOrderPopup close={closeQuickOrderPopup} />
          </div>
        </div>
      </div>
      <div id="cd-shadow-layer" onClick={cartboxClose}></div>
      {<CartSummary />}
    </div>
  );
}

export default HeaderIhateIroning;
